<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewEmployee"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchEmployees"
            @resetFilters="resetFilters"
            @importData="importEmployees"
            @removeItem="removeEmployee"
            @removeSelectedItems="removeEmployees"
            @printList="printEmployeesList"
            v-model:printModalVisible="printModalVisible1"
            :printTitle="printTitle1"
            :pdfUrl="pdfUrl"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="employeesList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
            :showDetails="showDetails"
            :detailsTitle="detailsTitle"
            @hideDetails="hideDetails"
        />
    </div>
    <MovableModal v-model:visible="transModalVisible" :title="transTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="trans_modal_loader" @showLoader="showTransModalLoader" @hideLoader="hideTransModalLoader" @closeModal="closeTransModal">
        <DynamicForm 
            :fields="formFields2" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="changeEmployeeStatus" @handleReset="handleReset1"
        />
    </MovableModal>
    <MovableModal v-model:visible="docModalVisible" :title="docTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="doc_modal_loader" @showLoader="showDocModalLoader" @hideLoader="hideDocModalLoader" @closeModal="closeDocModal">
        <DynamicForm 
            :fields="docFormFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="generateDocument" @handleReset="handleDocReset"
        />
    </MovableModal>
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="emp_modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis1" :flex_basis_percentage="flex_basis_percentage1" 
            :displayButtons="displayButtons" @handleSubmit="editEmployeeBiodata" @handleReset="handleReset">
        <template v-slot:additional-content>
            <div class="border border-slate-200 rounded relative py-3 mt-3 px-2 flex">
                <h3 class="font-bold absolute top-[-13px] left-5 bg-white text-sm">Emergency Contact Details</h3>
                <div class="px-3">
                    <DynamicForm :fields="additionalFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" @handleReset="handleReset"/>
                </div>
            </div>
        </template>
        </DynamicForm>  
    </MovableModal>
    <PrintModal v-model:visible="printModalVisible" :title="printTitle" >
        <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
    </PrintModal>

</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount,watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintJS from 'print-js';
import MovableModal from '@/components/MovableModal.vue';
import DynamicForm from '@/components/NewDynamicForm.vue';
import SearchableDropdown from '@/components/SearchableDropdown.vue';
import Swal from 'sweetalert2';
import PrintModal from '@/components/PrintModal.vue';

export default{
    name: 'Employees',
    components:{
        PageComponent,MovableModal,SearchableDropdown,DynamicForm,PrintModal
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const { formatDate } = useDateFormatter();
        const { getYear } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('');
        const modal_loader = ref('none');
        const displayButtons = ref(true);
        const depComponentKey = ref(0);
        const userComponentKey = ref(0);
        const groupComponentKey = ref(0);
        const trans_modal_loader = ref('none');
        const doc_modal_loader = ref('none');
        const docModalVisible = ref(false);
        const depModalVisible = ref(false);
        const title = ref('Edit Employee Biodata');
        const docTitle = ref('Generate Employee Document');
        const idField = 'employee_id';
        const addButtonLabel = ref('New Employee');
        const addingRight = ref('Adding Employees');
        const removingRight = ref('Deleting Employees');
        const rightsModule = ref('HR');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const employeesList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const showDetails = ref(false);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const detailsTitle = ref('Employee Documents');
        const transTitle = ref('Changing Employment Status');
        const transModalVisible = ref(false);
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Preview Employee Document');
        const printModalVisible1 = ref(false);
        const printTitle1 = ref('Print Employee List');
        const dropdownWidth = ref("500px")
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const emp_modal_width = ref('70vw');
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const flex_basis1 = ref('');
        const flex_basis_percentage1 = ref('');
        const showModal = ref(false);
        const grpArray = computed(()=> store.state.Pay_Groups.groupArr);
        const selectedEmployee = computed(()=> store.state.Employees.selectedEmployee);
        const selectedDepartment = computed(()=> store.state.Employees.selectedDepartment);
        const selectedSupervisor = computed(()=> store.state.Employees.selectedSupervisor);
        const isEditing = computed(()=> store.state.Employees.isEditing);
        const depArray = computed(() => store.state.Departments.depArr);
        const usersArray = computed(() => store.state.userData.userArr);
        const departmentID = ref('');
        const supervisorID = ref('');
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Staff No", key:"staff_number"},
            {label: "Employee Name", key:"employee_name"},
            {label: "Phone No", key: "phone_number"},
            {label: "Email", key:"email"},
            {label: "Department", key:"employee_department"},
            {label: "Gender", key:"gender"},
            {label: "Title", key:"job_title"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Employee', rightName: 'Editing Employees'},
            {name: 'view', icon: 'fa fa-file-pdf-o', title: 'View Profile', rightName: 'Viewing Employee Profile'},
            {name: 'transfer', icon: 'fa fa-exchange', title: 'Change Employment Status', rightName: 'Editing Employees'},
            {name: 'invite', icon: 'fa fa-paper-plane', title: 'Invite Employee', rightName: 'Inviting Employees To Portal'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Employee', rightName: 'Deleting Employees'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const unitID = ref("");
        const employeeID = ref("");
        const payGroupID = ref("");
        
        const fetchPayGroups = async() =>{
            await store.dispatch('Pay_Groups/fetchPayGroups', {company:companyID.value})
        };
        const handleSelectedPayGroup = async(option) =>{
            await store.dispatch('Pay_Groups/handleSelectedPayGroup', option)
            payGroupID.value = store.state.Pay_Groups.groupID;
        };
        const clearSelectedPayGroup = async() =>{
            await store.dispatch('Pay_Groups/updateState', {groupID: ''});
            payGroupID.value = store.state.Pay_Groups.groupID;
        };
        const name_search = ref('');
        const staff_number_search = ref("");
        const active_status_search = ref("Active");
        const phone_number_search = ref("");
        const gender_search = ref("");
 
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: name_search, width:48,},
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:48,},
            {type:'text', placeholder:"Phone No...", value: phone_number_search, width:48,},
            {
                type:'dropdown', placeholder:"Gender..", value: gender_search, width:40,
                options: [{text:'Male',value:'Male'},{text:'Female',value:'Female'},{text:'Others',value:'Others'}]
            },
            {
                type:'dropdown', placeholder:"Status..", value: active_status_search, width:40,
                options: [{text:'Active',value:'Active'},{text:'Resigned',value:'Resigned'},{text:'Dismissed',value:'Dismissed'},{text:'Retired',value:'Retired'},{text:'Died',value:'Died'}]
            },
            {
                type:'search-dropdown', value: payGroupID.value, width:48, componentKey: groupComponentKey,
                selectOptions: grpArray, optionSelected: handleSelectedPayGroup,
                searchPlaceholder: 'Pay Group...', dropdownWidth: '200px',
                clearSearch: clearSelectedPayGroup
            },
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const importEmployees = () =>{
            store.commit('pageTab/ADD_PAGE', {'HR':'Import_Employees'})
            store.state.pageTab.hrActiveTab = 'Import_Employees';
        }
        const removeEmployee = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    employee: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Employees/deleteEmployee',formData)
                    if(response && response.status == 200){
                        toast.success("Employee Removed Succesfully");
                        searchEmployees();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Employee: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Employee") 
            }else{
                toast.error("Please Select An Employee To Remove")
            }
        }
        const removeEmployees = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    employee: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Employees/deleteEmployee',formData)
                    if(response && response.status == 200){
                        toast.success("Employee(s) Removed Succesfully");
                        searchPropertys();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Employee: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Employee To Remove")
            }
        };
        const showTransModalLoader = () =>{
            trans_modal_loader.value = "block";
        }
        const hideTransModalLoader = () =>{
            trans_modal_loader.value = "none";
        }
        const formFields2 = ref([]);
        const updateFormFields2 = () => {
            formFields2.value = [
                { type: 'dropdown', name: 'employee_status',label: "Employee Status", value: '', placeholder: "", required: true, options: [{ text: 'Active', value: 'Active' }, { text: 'Resigned', value: 'Resigned' }, { text: 'Dismissed', value: 'Dismissed' }, { text: 'Retired', value: 'Retired' }, { text: 'Died', value: 'Died' }] },
                { type: 'date', name: 'exit_date', label: "Exit Date", value: '', required: false, maxDate: formatDate(current_date) },
                { type: 'textarea', name: 'exit_reason', label: "Exit Reason", value: '', required: false, placeholder: "Reason for exiting employee" ,textarea_rows: '4', textarea_cols: '56'},
            ]
        };
        const changeEmployeeStatus = async() =>{
            showTransModalLoader();
            let formData = {
                employee: employeeID.value,
                employee_status: formFields2.value[0].value,
                user: userID.value,
                company: companyID.value
            }
            axios.post(`api/v1/change-employee-status/`,formData)
            .then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Success")
                    closeTransModal();
                }else{
                    toast.error("Error Changing Employee Status");
                }                   
            })
            .catch((error)=>{
                toast.error(error.message)
                hideTransModalLoader();
            })
            .finally(()=>{
                hideTransModalLoader();
                searchEmployees();
            })    
        };
        const employeePortalInvitation = async(employee_id) =>{
            let formData = {
                employee: employee_id,
                user: userID.value,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Invite To Portal?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Invite Employee!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/invite-employee-portal/`,formData)
                .then((response)=>{
                if(response.data.msg == "Success"){
                    Swal.fire("Employee invited succesfully!", {
                        icon: "success",
                    }); 
                    searchEmployees();
                }else if(response.data.msg == "Exists"){
                    Swal.fire("Employee Already Exists!", {
                        icon: "warning",
                    }); 
                    searchEmployees();
                }else if(response.data.msg == "Failed"){
                    Swal.fire("Invalid Email Address!", {
                        icon: "warning",
                    }); 
                    searchEmployees();
                }else{
                    Swal.fire({
                    title: "Error Inviting Employee",
                    icon: "warning",
                    });
                }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
            }else{
                Swal.fire(`Employee has not been invited!`);
            }
            })     
        };
        const closeTransModal = () =>{
            transModalVisible.value = false;
            employeeID.value = null;
            hideTransModalLoader();
        };
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
       
        const searchEmployees = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: name_search.value,
                staff_number: staff_number_search.value,
                active_status: active_status_search.value || "Active",
                gender: gender_search.value,
                phone_number: phone_number_search.value,
                company_id: companyID.value,
                pay_group: payGroupID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/employees-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                employeesList.value = response.data.results;
                store.commit('Employees/LIST_EMPLOYEES', employeesList.value)
                propResults.value = response.data;
                propArrLen.value = employeesList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchEmployees(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            name_search.value = "";
            gender_search.value = "";
            phone_number_search.value = "";
            active_status_search.value = "Active";
            staff_number_search.value = "";
            payGroupID.value = "";
            groupComponentKey.value += 1;
            searchEmployees();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchEmployees();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchEmployees();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchEmployees();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchEmployees();
            // scrollToTop();
        }
        const addNewEmployee = async() =>{
            store.commit('Employees/initializeStore');
            await store.dispatch('Employees/updateState', {currentTab: 'Employee_Biodata',selectedEmployee: null,selectedEmployeeID: null,selectedSupervisor: null,selectedCurrency: null,selectedDepartment:null,selectedPayGroup: null,selectedBank: null,employeeDeductions: [],isEditing: false});
            store.commit('pageTab/ADD_PAGE', {'HR':'Employee_Details'});
            store.state.pageTab.hrActiveTab = 'Employee_Details';          
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                await store.dispatch('Employees/updateState', {currentTab: 'Employee_Biodata',selectedEmployee: null,selectedEmployeeID: null,selectedSupervisor: null,selectedCurrency: null,selectedDepartment:null,selectedPayGroup: null,selectedBank: null,employeeDeductions: [],employeeBenefits: [],isEditing: false});
                store.dispatch('Employees/updateState', {tenantCompanyID: companyID.value})
                const employeeID = row[idField];
                let formData = {
                    company: companyID.value,
                    employee: employeeID
                }
                await store.dispatch('Employees/fetchEmployee',formData).
                then(()=>{
                    store.commit('pageTab/ADD_PAGE', {'HR':'Employee_Details'})
                    store.state.pageTab.hrActiveTab = 'Employee_Details';
                })
            }else if(action == 'delete'){
                const employeeID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    employee: employeeID,
                    user: userID.value,
                }
                await store.dispatch('Employees/deleteEmployee',formData).
                then(()=>{
                    searchEmployees();
                })
            }else if(action == 'view'){
                await store.dispatch('Employees/updateState', {currentTab: 'Employee_Biodata',selectedEmployee: null,selectedEmployeeID: null,selectedSupervisor: null,selectedCurrency: null,selectedDepartment:null,selectedPayGroup: null,selectedBank: null,employeeDeductions: [],employeeBenefits: [],isEditing: false});
                const employeeID = row[idField];
                let formData = {
                    company: companyID.value,
                    employee: employeeID
                }
                await store.dispatch('Employees/fetchEmployeeDetails',formData)
                store.commit('pageTab/ADD_PAGE', {'HR':'Employee_Profile'})
                store.state.pageTab.hrActiveTab = 'Employee_Profile';
            }else if(action == 'transfer'){
                flex_basis.value = "1/2";
                flex_basis_percentage.value = "50";
                updateFormFields2();
                hideTransModalLoader();
                employeeID.value = row['employee_id'];
                transModalVisible.value = true;
            }else if(action == 'invite'){
                let employee_id = row['employee_id'];
                employeePortalInvitation(employee_id);
            }else if(action == 'generate-document'){
                flex_basis.value = "1/2";
                flex_basis_percentage.value = "50";
                hideDocModalLoader();
                employeeID.value = row['employee_id'];
                docModalVisible.value = true;
            }
        };
        
        const printEmployeesList = () =>{
            showLoader();
            let formData = {
                employee_name: name_search.value,
                staff_number: staff_number_search.value,
                active_status: active_status_search.value || "Active",
                gender: gender_search.value,
                phone_number: phone_number_search.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-employees-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob1);
                        pdfUrl.value = url;
                        printModalVisible1.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const hideDetails = async() =>{
            showDetails.value = false;
        };
        const dropdownOptions = ref([
            {label: 'Edit Employee Biodata', action: 'employee-biodata', icon: 'fa-edit', colorClass: 'text-blue-600', rightName: 'Editing Employees'},
            {label: 'Generate Document', action: 'generate-document', icon: 'fa-cloud-upload', colorClass: 'text-blue-600', rightName: 'Adding Employees'},
            
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'generate-document'){
                flex_basis.value = "1/2";
                flex_basis_percentage.value = "50";
                hideDocModalLoader();
                employeeID.value = selectedIds.value[0];
                docModalVisible.value = true;
            }else if(option == 'employee-biodata'){
                if(selectedIds.value.length > 1){
                    toast.error("You have selected more than 1 Employee") 
                    return;
                }else if(selectedIds.value.length < 1){
                    toast.error("Please Select An Employee To Edit")
                    return;
                }
                await store.dispatch('Employees/updateState', {currentTab: 'Employee_Biodata',selectedEmployee: null,selectedEmployeeID: null,selectedSupervisor: null,selectedCurrency: null,selectedDepartment:null,selectedPayGroup: null,selectedBank: null,employeeDeductions: [],employeeBenefits: [],isEditing: false});
                const employeeID = selectedIds.value[0];
                let formData = {
                    company: companyID.value,
                    employee: employeeID
                }
                await store.dispatch('Employees/fetchEmployee',formData).
                then(()=>{
                    modal_left.value = "250px";
                    flex_basis1.value = "1/4";
                    flex_basis_percentage1.value = "25";
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.333';
                    depModalVisible.value = true;
                })
            }
        };
        const docFormFields = ref([
            { type: 'date', name: 'issue_date',label: "Date", value: formatDate(current_date), required: false, maxDate: formatDate(current_date) },
            { type: 'text', name: 'year',label: "Year", value: getYear(current_date), required: false, maxDate: getYear(current_date) },
            { type: 'dropdown', name: 'document_type',label: "Document Type", value: '', placeholder: "", required: true, options: [{ text: 'Individual P9 Form', value: 'Individual P9 Form' }, { text: 'Batch P9 Form', value: 'Batch P9 Form' }] },
        ]);
        const handleDocReset = () =>{
            for(let i=0; i < docFormFields.value.length; i++){
                docFormFields.value[i].value = '';
            }
            employeeID.value = "";
        }
        const showDocModalLoader = () =>{
            doc_modal_loader.value = "block";
        }
        const hideDocModalLoader = () =>{
            doc_modal_loader.value = "none";
        }
        const generateDocument = async() =>{
            showDocModalLoader();
            let formData = {
                employee: employeeID.value,
                date: docFormFields.value[0].value,
                year: docFormFields.value[1].value,
                document_type: docFormFields.value[2].value,
                user: userID.value,
                company: companyID.value
            }
            axios.post(`api/v1/generate-employee-document-pdf/`,formData, { responseType: 'blob' })
            .then((response)=>{
                if (response && response.status === 200) {
                    handleDocReset();
                    const blob1 = new Blob([response.data], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob1);
                    pdfUrl.value = url;
                    printModalVisible.value = true;
                    closeDocModal();
                }                   
            })
            .catch((error)=>{
                toast.error(error.message)
                hideDocModalLoader();
            })
            .finally(()=>{
                hideDocModalLoader();
            })
        
        };
        const closeDocModal = () =>{
            docModalVisible.value = false;
            handleDocReset();
            hideDocModalLoader();
        };
        
        const fetchDepartments = async() =>{
            await store.dispatch('Departments/fetchDepartments', {company:companyID.value});
        };
        const handleSelectedDepartment = async(option) =>{
            await store.dispatch('Departments/handleSelectedDepartment', option)
            departmentID.value = store.state.Departments.depID;

        };
        const clearSelectedDepartment = async() =>{
            await store.dispatch('Departments/updateState', {depID: ''});
            departmentID.value = store.state.Departments.depID;    
        };
        const fetchUsers = async() =>{
            await store.dispatch('userData/fetchUsers', {company:companyID.value});
        };
        const handleSelectedSupervisor = async(option) =>{
            await store.dispatch('userData/handleSelectedUser', option)
            supervisorID.value = store.state.userData.userID;

        };
        const clearSelectedSupervisor = async() =>{
            await store.dispatch('userData/updateState', {supervisorID: ''});
            supervisorID.value = store.state.userData.supervisorID;
        };
        const departmentValue = computed(() => {
           return (selectedEmployee.value && selectedEmployee.value.employee_department && !departmentID.value) ? selectedEmployee.value.employee_department.department_id : departmentID.value;
        });
        const supervisorValue = computed(() => {
           return (selectedEmployee.value && selectedEmployee.value.supervisor && !supervisorID.value) ? selectedEmployee.value.supervisor.user_id : supervisorID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () =>{
            formFields.value = [
                { type: 'text', name: 'staff_number',label: "Staff Number", value: selectedEmployee.value?.staff_number || '', required: false },
                { type: 'text', name: 'employee_name',label: "Employee Name", value: selectedEmployee.value?.employee_name || '', required: true },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: selectedEmployee.value?.phone_number || '', required: true, placeholder: '' },
                { type: 'text', name: 'id_number',label: "ID Number", value: selectedEmployee.value?.id_number || '', required: true, placeholder: '' },
                { type: 'date', name: 'dob',label: "D.O.B", value: selectedEmployee.value?.dob || '', required: false, placeholder: '' },
                { type: 'dropdown', name: 'gender',label: "Gender", value: selectedEmployee.value?.gender || '', placeholder: "", required: true, options: [{ text: 'Male', value: 'Male' }, { text: 'Female', value: 'Female' }, { text: 'Others', value: 'Others' }] },
                { type: 'text', name: 'email',label: "Email", value: selectedEmployee.value?.email || '', required: false },
                { type: 'text', name: 'kra_pin',label: "Tax Pin", value: selectedEmployee.value?.kra_pin || '', required: false },
                { type: 'dropdown', name: 'marital_status',label: "Marital Status", value: selectedEmployee.value?.marital_status || '', placeholder: "", required: true, options: [{ text: 'Single', value: 'Single' }, { text: 'Married', value: 'Married' },{ text: 'Separated', value: 'Separated' }, { text: 'Divorced', value: 'Divorced' },{ text: 'Widowed', value: 'Widowed' }] },
                { type: 'text', name: 'country',label: "Country", value: selectedEmployee.value?.country || 'Kenya', required: true },
                { type: 'text', name: 'address',label: "Address", value: selectedEmployee.value?.address || '', required: false },
                { type: 'text', name: 'job_title',label: "Job Title", value: selectedEmployee.value?.job_title || '', required: true },
                {  
                    type:'search-dropdown', label:"Department", value: departmentValue.value, componentKey: depComponentKey,
                    selectOptions: depArray, optionSelected: handleSelectedDepartment, required: false,
                    searchPlaceholder: 'Select Department...', dropdownWidth: '500px', updateValue: selectedDepartment.value,
                    clearSearch: clearSelectedDepartment
                },
                {  
                    type:'search-dropdown', label:"Supervisor", value: supervisorValue.value, componentKey: userComponentKey,
                    selectOptions: usersArray, optionSelected: handleSelectedSupervisor, required: false,
                    searchPlaceholder: 'Select Supervisor...', dropdownWidth: '500px', updateValue: selectedSupervisor.value,
                    clearSearch: clearSelectedSupervisor
                },
                {required:false}
            ]
        };
        const additionalFields = ref([]);
        const updateAdditionalFormFields = () => {
            additionalFields.value = [
                { type: 'text', name: 'contact_names',label: "Name", value: selectedEmployee.value?.contact_names ||'', required: false },
                { type: 'text', name: 'contact_phone_number',label: "Phone Number", value: selectedEmployee.value?.contact_phone_number ||'', required: false },
                { type: 'text', name: 'contact_email',label: "Email", value: selectedEmployee.value?.contact_email ||'', required: false },
                { type: 'text', name: 'contact_relationship',label: "Relationship", value: selectedEmployee.value?.contact_relationship ||'', required: false },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            for(let i=0; i < additionalFields.value.length; i++){
                additionalFields.value[i].value = '';
            }
            departmentID.value = "";
            supervisorID.value = "";
            userComponentKey.value += 1;
            depComponentKey.value += 1;
            employeeID.value = "";
        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const editEmployeeBiodata = async() =>{
            showModalLoader();
            let formData = {
                employee: selectedEmployee.value?.employee_id,
                staff_number: formFields.value[0].value,
                employee_name: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                id_number: formFields.value[3].value,
                dob: formFields.value[4].value || null,
                gender: formFields.value[5].value,
                email: formFields.value[6].value,
                kra_pin: formFields.value[7].value,
                marital_status: formFields.value[8].value,
                country: formFields.value[9].value,
                address: formFields.value[10].value,
                job_title: formFields.value[11].value,
                department: departmentValue.value,
                supervisor: supervisorValue.value,
                contact_names: additionalFields.value[0].value,
                contact_phone_number: additionalFields.value[1].value,
                contact_email: additionalFields.value[2].value,
                contact_relationship: additionalFields.value[3].value,
                user: userID.value,
                company: companyID.value
            }
            axios.post(`api/v1/update-employee-biodata/`,formData)
            .then((response)=>{
                if (response.data.msg == "Success") {
                    handleReset();
                    toast.success("Success");
                    closeModal();
                    searchEmployees();
                }                 
            })
            .catch((error)=>{
                toast.error(error.message)
                hideModalLoader();
            })
            .finally(()=>{
                hideModalLoader();
            })
        
        };
        const closeModal = () =>{
            depModalVisible.value = false;
            handleReset();
            hideModalLoader();
        };
        watch([selectedDepartment, selectedEmployee, selectedSupervisor], () => {
            if (selectedDepartment.value && selectedEmployee.value && selectedSupervisor.value) {
                userComponentKey.value += 1;
                depComponentKey.value += 1;
                updateFormFields();
                updateAdditionalFormFields();
            }else if(selectedDepartment.value && selectedEmployee.value){
                depComponentKey.value += 1;
                updateFormFields();
                updateAdditionalFormFields();
            }else if(selectedEmployee.value && selectedSupervisor.value){
                userComponentKey.value += 1;
                updateFormFields();
                updateAdditionalFormFields();
            }else if(selectedEmployee.value){
                updateFormFields();
                updateAdditionalFormFields();
            }else{
                updateFormFields();
                updateAdditionalFormFields();
            }
            
        }, { immediate: true });
        onBeforeMount(()=>{
            searchEmployees();
            fetchPayGroups();
            fetchDepartments();
            fetchUsers();
        })
        return{
            searchEmployees,resetFilters, addButtonLabel, searchFilters, tableColumns, employeesList,dropdownWidth,displayButtons,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,flex_basis,flex_basis_percentage,flex_basis1,flex_basis_percentage1,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick,showDetails,detailsTitle,hideDetails,
            submitButtonLabel, showModal, addNewEmployee, showLoader, loader, hideLoader, importEmployees, removeEmployee, removeEmployees,
            handleSelectionChange,addingRight,removingRight,rightsModule,printEmployeesList,selectSearchQuantity,selectedValue,
            modal_left,modal_top,modal_width,trans_modal_loader,transModalVisible,transTitle,showTransModalLoader,hideTransModalLoader,changeEmployeeStatus,closeTransModal,
            dropdownOptions,handleDynamicOption,doc_modal_loader,docModalVisible,docTitle,docFormFields,generateDocument,handleDocReset,showDocModalLoader,hideDocModalLoader,closeDocModal,
            pdfUrl,printModalVisible,printTitle,printModalVisible1,printTitle1,formFields2,
            modal_loader,emp_modal_width,depModalVisible,title,formFields,handleReset,showModalLoader,hideModalLoader,editEmployeeBiodata,closeModal,additionalFields
        }
    }
};
</script>